const bellemare = {
  "id": "bellemare",
  "title": "BelleMare Residence",
  "description": {
    "en": "Belle Mare Residential Building is a first-class residence with apartments, located in the greenery of the oldest Black Sea resort 'St. St. Constantine and Helena'. It occupies one of the last free plots by the sea, in the most picturesque part of the resort — directly next to the iconic 'Grand Hotel Varna' and only 200 m from the sea shore.",
    "bg": "Проектът се отличава с модерен архитектурен дизайн и предлага премиум апартаменти с морска панорама, изработени от висококачествени материали и оборудвани с енергийно ефективни системи. За удобство и комфорт на обитателите е предвиден подземен паркинг, а озеленените градини създават усещане за спокойствие и изтънченост.\n\nBelle Mare гарантира безопасност и спокойствие с 24/7 система за сигурност, като съчетава лукс, природа и удобства в непосредствена близост до плажа и всички важни точки на курорта.\n\nТова е дом, който предлага изискан морски лайфстайл и устойчиво качество на живот – пространство за живот и инвестиция, което вдъхновява.",
    "de": "Das Wohngebäude Belle Mare ist eine erstklassige Residenz mit Apartments, gelegen im Grün des ältesten Schwarzmeer-Resorts 'St. St. Konstantin und Helena'. Es belegt eines der letzten freien Grundstücke am Meer, im malerischsten Teil des Resorts — direkt neben dem ikonischen 'Grand Hotel Varna' und nur 200 m vom Meeresufer entfernt.",
    "ru": "Жилой дом Belle Mare — это первоклассная резиденция с апартаментами, расположенная среди зелени самого старого черноморского курорта «Св. Св. Константин и Елена». Занимает один из последних свободных участков у моря, в самой живописной части курорта — непосредственно рядом с эмблематичным «Гранд Отелем Варна» и всего в 200 м от морского берега."
  },
  "location": {
    "en": "St. Constantine and Helena, Varna",
    "bg": "Св. Константин и Елена, Варна",
    "de": "St. Konstantin und Helena, Varna",
    "ru": "Св. Константин и Елена, Варна"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.160995321042!2d28.005015576537534!3d43.22708407988594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a45741b886aee7%3A0x563a20c394304f95!2z0JbQuNC70LjRidC90LAg0YHQs9GA0LDQtNCwIEJlbGxlIE1hcmU!5e0!3m2!1sen!2sbg!4v1759424486250!5m2!1sen!2sbg",
    "directionsUrl": "https://maps.app.goo.gl/JA8uYikv9cQEnZnx9",
    "coordinates": {
      "lat": 43.22714,
      "lng": 28.007891
    }
  },
  "type": "Residential Complex",
  "year": "2023",
  "status": "Completed",
  "heroImage": "/projects/BelleMare/IMG_4750.JPG",
  "images": [
    "/projects/BelleMare/IMG_4750.JPG",
    "/projects/BelleMare/IMG_4750 2.JPG",
    "/projects/BelleMare/IMG_4752.JPG",
    "/projects/BelleMare/IMG_4752 2.JPG",
    "/projects/BelleMare/IMG_7358.JPG",
    "/projects/BelleMare/IMG_7365.JPG",
    "/projects/BelleMare/IMG_7367.JPG"
  ],
  "features": {
    "en": [
      "Modern architectural design",
      "Premium sea view apartments",
      "High-quality construction materials",
      "Energy-efficient systems",
      "Underground parking",
      "Landscaped gardens",
      "24/7 security system",
      "Proximity to beach and amenities"
    ],
    "bg": [
      "Модерен архитектурен дизайн",
      "Премиум апартаменти с морска гледка",
      "Висококачествени строителни материали",
      "Енергийно ефективни системи",
      "Подземен паркинг",
      "Озеленени градини",
      "24/7 система за сигурност",
      "Близост до плажа и удобства"
    ],
    "de": [
      "Modernes architektonisches Design",
      "Premium-Meerblick-Wohnungen",
      "Hochwertige Baumaterialien",
      "Energieeffiziente Systeme",
      "Tiefgarage",
      "Landschaftsgärten",
      "24/7 Sicherheitssystem",
      "Nähe zu Strand und Annehmlichkeiten"
    ],
    "ru": [
      "Современный архитектурный дизайн",
      "Премиум апартаменты с морским видом",
      "Высококачественные строительные материалы",
      "Энергоэффективные системы",
      "Подземная парковка",
      "Ландшафтные сады",
      "Система безопасности 24/7",
      "Близость к пляжу и удобствам"
    ]
  },
  "stats": {
    "area": "2,500 m²",
    "floors": "6",
    "units": "24"
  },
  "availableApartments": 0
};

export default bellemare;
